<template>
  <div class="emoji-list">
    <ul class="list-unstyled d-flex justify-content-between flex-wrap mb-0">
      <li
        class="emoji-wrapper flex-center pointer"
        v-for="emoji in emojis"
        :title="emoji.name"
        @click="$emit('select', emoji)"
        :key="emoji.short_name"
      >
        <div class="emoji" :style="getEmojiStyle(emoji)"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import client from '@/constants/client'

/**
 * This component shows the list of emojis. It accepts prop (emojis) which is an array of emojis object
 * @emits
 * - select
 */
export default {
  name: 'EmojisList',
  props: ['emojis'],
  methods: {
    getEmojiStyle(emoji) {
      return {
        backgroundImage: `url(/emojis/${client.emojiType}/v1/${emoji.image})`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.emoji {
  @include dimension(22px, 22px);
  background-size: contain;
}

.emoji-wrapper {
  @include dimension(36px, 36px);
  padding: 6px;
  border-radius: 50%;
  content-visibility: auto;
  transition: all 100ms ease-out;

  &:hover {
    background-color: $activeQuaternary;
    transform: scale(1.2);
    box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
}
.emoji-list ul {
  gap: 6px;
}
</style>
